import { isBrowser } from 'react-device-detect';

export default function(loggedInUser){
    if (loggedInUser) { //different height navbar if someones logged in
        return 56.8;
    } else {
        return isBrowser ? 72 : 56.8;
    }
}